/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Submarine theme customisations for product page.
 */

const body = document.querySelector('body');
const bundleTemplate = body.classList.contains('bundle');

(function() {

  var productJsonElement = document.querySelector('[data-product-json]');
  if (!productJsonElement) { return; }

  var productData = JSON.parse(productJsonElement.innerHTML);

  // build a mapping of variants to active presale campaigns
  var variantPresaleCampaigns = {};
  for(var i = 0; i < productData.product.variants.length; i++) {
    var variant = productData.product.variants[i];
    for(var j = 0; j < productData.presale_campaigns.length; j++) {
      var presaleCampaign = productData.presale_campaigns[j];
      if(presaleCampaign.status == 'launched') {
        for(var k = 0; k < variant.selling_plan_allocations.length; k++) {
          var variantSellingPlanId = 'gid://shopify/SellingPlan/' + variant.selling_plan_allocations[k].selling_plan_id;
          if(presaleCampaign.selling_plan_gid == variantSellingPlanId) {
            variantPresaleCampaigns[variant.id] = presaleCampaign;
          }
        }
      }
    }
  }

  function updatePresales(variantId, variantAvailable) {
    console.log('updatePresales', variantId, variantAvailable);

    var activePresaleCampaign = variantAvailable ? variantPresaleCampaigns[variantId] : null;

    // if the variant is available and has an active presale campaign
    if(activePresaleCampaign) {
      var addToCartButtonElement = document.querySelector('.product-form__add-button');
      addToCartButtonElement.innerHTML = window.languages.productFormPreOrder;
    }

    // show or hide the presale label
    var presaleLabel = document.querySelector('.product-meta .product-label--pre-order');
    if(presaleLabel) {
      presaleLabel.style.display = activePresaleCampaign ? 'inline-block' : 'none';
    }

    // add or remove
    var infoContentElement = document.querySelector('.product-form__info-content');
    if(infoContentElement) {
      if(activePresaleCampaign) {
        infoContentElement.classList.add('product-form__info-content--presale');
      } else {
        infoContentElement.classList.remove('product-form__info-content--presale');
      }
    }

    // banner
    var presaleBannerElement = document.querySelector('.product-form__presale_banner');
    var presaleBannerDateElement = document.querySelector('.product-form__presale_banner__date');
    var sellingPlanElement = presaleBannerElement ? presaleBannerElement.querySelector('[name="selling_plan"]') : null;
    if(presaleBannerElement) {
      presaleBannerElement.style.display = activePresaleCampaign ? 'block' : 'none';

      if(presaleBannerDateElement && activePresaleCampaign) {
        console.log('heree');
        console.log(activePresaleCampaign);
        var date = new Date(activePresaleCampaign.fulfil_at);
        //presaleBannerDateElement.innerText = date.toDateString();
      }

      // selling plan selector
      if(sellingPlanElement) {
        sellingPlanElement.value = activePresaleCampaign ? activePresaleCampaign.selling_plan_gid.replace('gid://shopify/SellingPlan/', '') : null;
      }
    }
  }

  // add event listener to handle a change in variant
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant;
    updatePresales(variant.id, variant.available);
  });

  updatePresales(productData.selected_variant_id, productData.selected_variant_available);
})();



jQuery(document).ready(function(){
   var prods = jQuery('.product-item__title');
   for(var i = 0;i < prods.length; i++){
    jQuery('.product-item__title').eq(i).html(jQuery('.product-item__title').eq(i).html().replace(' - Quick Dry & UV Rated', ''));
    jQuery('.product-item__title').eq(i).html(jQuery('.product-item__title').eq(i).html().replace(' - Quick Dry &amp; UV Rated', ''));
   }
});

var ur = window.location.href;
if(ur.includes('/product')){
 jQuery(document).ready(function(){

var p = $('p.intro');
for(var i = 0; i < p.length; i++){

if(p.eq(i).html().includes('This design is able to be customised for your business, sports team or club.')){
  p.eq(i).remove();
}
}

    jQuery('.product-meta__title').eq(0).html(jQuery('.product-meta__title').eq(0).html().replace(' - Quick Dry & UV Rated', ''));
    jQuery('.product-meta__title').eq(0).html(jQuery('.product-meta__title').eq(0).html().replace(' - Quick Dry &amp; UV Rated', ''));


   
var kss = 0; var timerkss = setInterval(function(){
  if(jQuery('.ks-chart-container').length) {
	jQuery('span.product-form__option-name.text--strong').eq(0).append(jQuery('.ks-chart-container').eq(0))
clearInterval(timerkss);}if( kss > 200){clearInterval(timerkss);}kss++;}, 50);
   
   var curPrice = $('.product-form__info-content span.price.price--highlight').eq(0).text();
 setInterval(function(){ 
if($('.product-form__info-content span.price.price--highlight').eq(0).text() != curPrice){
//  var salePrice = parseFloat($('.product-form__info-content span.price.price--highlight').eq(0).text().substring(1)) - 20;
 // $('.product-form__info-content span.price.price--highlight .money').eq(0).html('$' + salePrice.toFixed(2))
//curPrice = $('.product-form__info-content span.price.price--highlight').eq(0).text();
}
}, 100);
}); 
}





var ur = window.location.href;
if(ur.includes('a/bundles')){
   setInterval(function(){ 
     if(jQuery('.bndlr-sections-status-container .bndlr-warning').length == 0){
 jQuery('.bndlr-sections-status-container').eq(0).append(jQuery('.bndlr-warning').eq(0));      
     }

}, 1000);
}




document.addEventListener('DOMContentLoaded', function() {
   var ur = window.location.href;
  if (ur.includes('/product')) {
  sticky();}
});

function sticky() {
 

    Element.prototype.appendAfterThis = function(element) {
      element.parentNode.insertBefore(this, element.nextSibling);
    };
  var ctaCopy = "SELECT YOUR SHIRT";
  if(window.location.href.includes('jacket')){
      var ctaCopy = "SELECT YOUR JACKET";
  }

    var sticky = document.createElement('div');
    sticky.innerHTML = '<div class="sash-st-container" id="sash-st-containerID"> <div class="sash-st-container__outer"> <div class="sash-product-cont"> <div class="sash-product-image"></div><div class="sash-col"> <p class="sash-product-name"></p><div class="sash-product-reviews yotpo"> <span class="yotpo-stars"> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span> <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span><span class="sr-only">5 star rating</span> </span> </div><div class="sash-product-price"></div></div></div><div class="sash-st-container__inner"> <div class="sash-st-item_column__button"><div class="sash-st-item__button" rel="nofollow">'+ctaCopy+'</div></div></div></div></div>';
    var y = document.getElementsByTagName('body');
    if (document.getElementsByClassName('sash-st-container').length == 0) {
      y[0].appendChild(sticky);

      document.querySelector('.sash-product-name').innerHTML = document.querySelector('.product-meta__title').innerHTML.replace(' - Quick Dry & UV Rated', '').replace(' - Quick Dry &amp; UV Rated', '');
      document.querySelector('.sash-product-image').innerHTML = "<img src='" + bcpo_product['images'][0] + "' class='st-product-image'>";

      document.querySelector('.sash-st-item__button').addEventListener('click', function() {
        if (!document.querySelector('.sash-st-item__button').classList.contains("sash-st-disabled")) {
          window.scrollTo({
            top: document.querySelector('.product-meta__title').offsetTop - 80,
            behavior: 'smooth'
          });
        }
      });
    };

    var mc = window.matchMedia("(min-width: 767px)");
    mc.addListener(slideShow);

    var elem = document.getElementById("sash-st-containerID");

    function slideShow() {
      document.querySelector('body').classList.add('sash-sticky');
    }

    function slideHide() {
      document.querySelector('body').classList.remove('sash-sticky');
    }

    window.addEventListener('scroll', function() {
      var y = window.pageYOffset;
      if (y > document.querySelectorAll('.simple-badges-outer-container')[0].offsetTop - 600) {
        slideShow();
      } else {
        slideHide();
      }
    });
  }


var ur = window.location.href;
if(ur.includes('/product')){

 var afff = 0; var timerafff = setInterval(function(){
  if(document.querySelector('afterpay-placement') != null && document.querySelector('.installment-container afterpay-placement') == null) {
    const installmentContainer = document.querySelectorAll('.installment-container')[0];
const afterpayPlacement = document.querySelectorAll('afterpay-placement')[0];
installmentContainer.appendChild(afterpayPlacement);
   setInterval(function(){ 
	const element = document.querySelector('afterpay-placement');
const shadowRoot = element.shadowRoot;
     const styleElement = document.createElement('style');
styleElement.textContent = `
span.afterpay-main-text {
    display: none!important;
}

button#logo-link {
    display: none!important;
}
`;
     shadowRoot.appendChild(styleElement);
}, 1000);
 setTimeout(function(){ 
 const installmentContainer = document.querySelectorAll('.installment-container')[0];
const popupWidget = document.querySelectorAll('[data-zm-widget="popup"]')[0];
installmentContainer.appendChild(popupWidget);
}, 1000);
   


}if( afff > 200){;}afff++;}, 50); 


   var zzz = 0; var timerzzz = setInterval(function(){
  if(document.querySelector('[data-zm-widget="popup"]') != null && document.querySelector('.installment-container [data-zm-widget="popup"]') == null) {
const installmentContainer = document.querySelectorAll('.installment-container')[0];
const popupWidget = document.querySelectorAll('[data-zm-widget="popup"]')[0];
installmentContainer.appendChild(popupWidget);
    
}if( zzz > 200){;}zzz++;}, 50); 
}






/* PRESALE */
if(!bundleTemplate){
 setInterval(function(){ 
if($('input[type=radio]:not(.ymq-Switch):checked').attr('presale') == "true"){
  $('button.product-form__add-button.button.button--primary').html('PRE-ORDER');
$('.dispatch-text').addClass('active');
  $('#orderType').attr('name', 'properties[Pre-sale]');
  $('#orderType').val('Expected delivery is within 6 weeks.');
            }
            else{
            $('button.product-form__add-button.button.button--primary').html('ADD TO CART');
             $('.dispatch-text').removeClass('active');
              $('#orderType').attr('name', '')
              $('#orderType').val('');
            }
}, 100);
} else {
  /**Additional code for the bundle**/

  document.querySelector('.dispatch-text').style.display = "block";
  const varOptions = document.querySelectorAll('.product-form__single-selector');
  const atcBtn = document.querySelector('.product-form__add-button');

  const ATCtoPRE =  function () {
    setTimeout(function () {
          atcBtn.innerText = 'PRE-ORDER';
    },500)
    
  }

  varOptions.forEach(varOption => {
    varOption.addEventListener('change',ATCtoPRE);
  })
      
}

/* END PRESALE */




var ur = window.location.href;
if(ur.includes('shorts')){
  jQuery(document).ready(function(){
 setInterval(function(){ 
if(jQuery('.block-swatch__radio:checked').eq(0).val() == "Charcoal"){
  jQuery('.product-gallery.product-gallery--with-thumbnails').addClass('charcoal');
}
   else{
    jQuery('.product-gallery.product-gallery--with-thumbnails').removeClass('charcoal'); 
   }
}, 50);
});
}


/*
 setInterval(function(){ 
let totalS = 0;
$('[data-item-qty]').not('.hs-product-47731596820775').not('.hs-product-46936213717287').not('.hs-product-46936217059623').each(function() {
  
    totalS += parseInt($(this).attr('data-item-qty'));
});
if(totalS > 2){
  console.log(totalS)
  jQuery('.hs-text-free-shipping').html('Congrats! You got a FREE shirt. Check out now to secure your savings')
}
   else{
     console.log(totalS)
   }
}, 1000);

*/


function getUrlParameter(name) {
    const url = new URL(window.location.href);
    const param = url.searchParams.get(name);
    return param;
}

// Save to cookies function
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

// Read cookie function
function getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        if (cookie[0] === name) {
            return cookie[1];
        }
    }
    return null;
}

// Check URL and set cookie if the parameter is found
const urlParam = getUrlParameter('promo'); // Change 'promo' to the desired URL parameter name
if (urlParam != null && urlParam.includes('ChristmasSale')) {
    setCookie('ChristmasSale', 'active', 7); // Save the cookie for 7 days
}


var ur = window.location.href;

 // Function to get URL parameter

// Function to add a specific product to the cart
function addProductToCart(productId, quantity = 1) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: productId,
            quantity: 1,
        }),
    })
    .then(response => response.json())
    .then(data => console.log('Product added:', data))
    .catch(error => console.error('Error adding product:', error));
}

// Monitor Shopify's cart form submission

jQuery(document).ready(function(){

var res = 0; var timerres = setInterval(function(){
  if(jQuery('.yotpo-bottom-line-basic-text').length) {
	jQuery('.yotpo-sr-bottom-line-text').eq(0).html(jQuery('.yotpo-bottom-line-basic-text').eq(0).html().split('on ')[1].replace(' reviews', '') + ' Reviews');
    jQuery('.yotpo-sr-bottom-line-text').eq(1).html(jQuery('.yotpo-bottom-line-basic-text').eq(0).html().split('on ')[1].replace(' reviews', '') + ' Reviews');
    jQuery('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel').show()
clearInterval(timerres);}if( res > 200){clearInterval(timerres);}res++;}, 50);

 setTimeout(function(){ 
  $('a.yotpo-sr-bottom-line-summary').click(function(e){
    console.log('hetre');
  e.preventDefault();
    window.scrollTo({
    top: document.querySelectorAll('div#yotpo-reviews-seo-page')[0].offsetTop,
    behavior: 'smooth'
});
}); 
}, 1000);



  setInterval(function(){ 
if (getCookie('ChristmasSale') === 'active') {
    const freeProductId = 49288237449511; // Replace with your free product's variant ID

    // Fetch the cart and check for other products and free product presence
fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
        const productsInCart = cart.items;
        const cartTotal = cart.total_price / 100; // Convert total price from cents to dollars

        // Find the line item ID for the free product if it exists in the cart
        const freeProductLineItem = productsInCart.find(item => item.id === freeProductId);

        if (cartTotal > 150 && !freeProductLineItem) {
            console.log('Adding free product to cart');
            // Add the free product if the cart total exceeds 150 and free product is not already in the cart
            addProductToCart(freeProductId);
        } else if (cartTotal <= 150 && freeProductLineItem) {
            console.log('Removing free product from cart');
            // Remove the free product if the cart total is 150 or less and free product exists in the cart
            document.querySelectorAll('.hs-item-cart-content.hs-product-49288237449511 span.hs-remove-item.hs-event-static')[0].click();
        } else {
            console.log('No action taken: Either free product not added or not removed.');
        }
    })
    .catch(error => console.error('Error checking cart:', error));

}




}, 2000);
             

});


 